import { render, staticRenderFns } from "./ContactInfoList.vue?vue&type=template&id=551e0f57&scoped=true"
import script from "./ContactInfoList.vue?vue&type=script&lang=js"
export * from "./ContactInfoList.vue?vue&type=script&lang=js"
import style0 from "./ContactInfoList.vue?vue&type=style&index=0&id=551e0f57&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551e0f57",
  null
  
)

export default component.exports